import client from "./client";
export const getPosts = ({ cursor, limit } = {}) => {
  const params = new URLSearchParams();
  if (cursor) params.set("cursor", cursor);
  if (limit) params.set("limit", limit);
  const query = params.toString();
  return client.get(`/posts${query ? `?${query}` : ""}`);
};
export const getUserPosts = (userId) => client.get(`/posts/${userId}`);
export const createPost = (formData) => client.post("/posts/createpost", formData);
export const deletePost = (id) => client.delete(`/posts/${id}`);
export const toggleLikePost = (postId) => client.post(`/posts/like/${postId}`);
export const repostPost = (postId, comment) => client.post(`/posts/repost/${postId}`, { comment });
export const toggleFavoritePost = (postId) => client.post(`/posts/favorite/${postId}`);
export const getMyFavoritePosts = () => client.get("/posts/favorites/mine");
export const addComment = (postId, content, parentId) => client.post(`/posts/${postId}/comments`, { content, parentId });
export const deleteComment = (postId, commentId) => client.delete(`/posts/${postId}/comments/${commentId}`);
